import React from "react"

export const RenderHtml: React.FC<{ html: string }> = ({ html }) => {
  // gastby-source-api plugin converts html with spaces to nonbreaking spaces, so convert back before inserting
  html = html.replace(/(?=\s)[^\r\n\t]/g, " ")

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  )
}
